import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { Mail } from "lucide-react";
const Footer = () => {
  return (
    <div className="qfs-footer">
      {/* Background dots pattern */}
      <div className="dots-background"></div>

      <div className="container">
        <div className="footer-grid">
          {/* Column 1: QFS LEDGER */}
          <div className="footer-column">
            <h2 className="footer-heading">QFS LEDGER</h2>
            <p className="footer-text">
              The QUANTUM ASSETS GLOBAL LEDGER has no comparison to anything
              that has ever been introduced to the world before. It has no peer;
              it has no equivalent in advanced technology of any other system
              before it. It is brand new. It reigns supreme in the technology it
              applies, in order to accomplish the one hundred percent financial
              security and transparency all currency account holders require.
              With the QFS, the monetary system of the world can easily be
              changed to encompass gold-backed currencies that completely
              eliminate the use of the old Cabal central banking system.
              Regrettably, to fully comprehend the advanced QFS-structure, there
              doesn't exist an equivalent technology to serve as an example.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-column">
            <h2 className="footer-heading">Quick Links</h2>
            <ul className="footer-links">
              <li>
                <Link to="/about" className="footer-link">
                  About
                </Link>
              </li>
              <li>
                <Link to="/signup" className="footer-link">
                  Register
                </Link>
              </li>
              <li>
                <Link to="/login" className="footer-link">
                  Login
                </Link>
              </li>

              <li>
                <Link to="/buyxrp" className="footer-link">
                  Buy XRP
                </Link>
              </li>

              <li>
                <Link to="/buyxlm" className="footer-link">
                  Buy XLM
                </Link>
              </li>
              
            </ul>
          </div>

          {/* Column 3: Our Services */}
          <div className="footer-column">
            <h2 className="footer-heading">Our Services</h2>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">
                  Digital Currency protection
                </Link>
              </li>
              <li>
                <Link to="/" className="footer-link">
                  Wallet Security System
                </Link>
              </li>
              <li>
                <Link to="/" className="footer-link">
                  Banking at your fingertips, anytime anywhere
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contacts */}
          <div className="footer-column">
            <h2 className="footer-heading">Contacts</h2>
            <div className="contact-items">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <div>
                  <p className="contact-label">Email:</p>
                  <a
                    href="mailto:support@quantumassetsgloballedger.com"
                    className="contact-link"
                  >
                    support@quantumassetsgloballedger.com
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <Mail className="contact-icon" />
                <div>
                  <p className="contact-label">Support:</p>
                  <a
                    href="mailto:support@quantumassetsgloballedger.com"
                    className="contact-link"
                  >
                    support@quantumassetsgloballedger.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-bar">
        <p>
          Copyright ©2018 - {new Date().getFullYear()}, @
          quantumassetsgloballedger.com. All Right Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
